import React, { createContext, useState, useContext } from "react";
import translations from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(localStorage.getItem("language") || "th");
  
    const changeLanguage = (lang) => {
      setLanguage(lang);
      localStorage.setItem("language", lang);
    };
  
    const t = (key) => {
      const keys = key.split(".");
      return keys.reduce((obj, k) => (obj && obj[k] ? obj[k] : key), translations[language]);
    };
    const fontFamily = language === "th" ? "'Kanit', sans-serif" : "'Kanit', sans-serif";
    return (
        <LanguageContext.Provider value={{ language, changeLanguage, t, fontFamily }}>
        {children}
      </LanguageContext.Provider>
    );
  };
export const useLanguage = () => useContext(LanguageContext);
